module.exports = __webpack_public_path__ + "img/MEX.732125cf.svg";